import React, { useState, useEffect } from "react";
import { Grid, Select, FormControl, MenuItem, Card } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import api from "../../api";
import { useSelector } from "react-redux";
import firefightingpump from "../../assets/Images/pump.png";
import dieselPumpImg from "../../assets/Images/Hydropneumatic.png";

const useStyles = makeStyles((theme) => ({
  root: { flexGrow: 1, marginTop: "-1vh" },
  formControl: {
    width: "max-content", minWidth: "100%",
    backgroundColor: "#eeeef5", fontFamily: "Arial", height: "6vh",
  },
  paper1: {
    background: "#FFFFFF 0% 0% no-repeat padding-box",
    boxShadow: "0px 0px 10px #0123B421", opacity: "1",
    borderRadius: "12px", height: "15vh",
    display: "flex", flexDirection: "column",
    justifyContent: "space-between", alignItems: "center", padding: "1vh 0",
  },
  cardHeading: {
    display: "flex", justifyContent: "center", alignItems: "center",
    color: "#000000", marginTop: "1vh", fontWeight: "bold",
    fontSize: "1.7vh", textAlign: "center",
  },
  select: {
    fontWeight: "bold", height: "6vh", borderRadius: "0.8vw", fontFamily: "Arial",
    "@media (min-width:1920px) and (max-width:2559.95px)": { fontSize: "2vh" },
    "& .MuiSvgIcon-root": { color: "white", backgroundColor: "#0123b4", borderRadius: "8px" },
    "& .MuiSelect-root": { marginTop: "-2vh" },
  },
  paper: {
    background: "#FFFFFF 0% 0% no-repeat padding-box",
    boxShadow: "1px 0px 8px 2px rgba(0, 0, 0, 0.14)",
    backgroundColor: "#fcfafa", padding: theme.spacing(2),
    textAlign: "center", color: theme.palette.text.secondary,
    borderRadius: "12px", opacity: "1",
  },
  pumpTypeCard: {
    background: "#FFFFFF 0% 0% no-repeat padding-box",
    boxShadow: "0px 0px 10px #0123B421", borderRadius: "12px",
    padding: "2vh", height: "100%", minHeight: "25vh",
  },
}));

export default function Eqp_Details() {
  const classes = useStyles();

  const [firePumpData, setFirePumpData] = useState({});
  const [dieselPumpData, setDieselPumpData] = useState({});
  const [fdata, setFdata] = useState("all");
  const zone_data = useSelector((state) => state.inDashboard.locationData);
  const [fid, setFId] = useState("all");
  const [floor, setFloor] = useState([]);
  const buildingID = useSelector((state) => state.isLogged.data.building.id);

  useEffect(() => {
    zone_data.sort((a, b) => (a.name > b.name ? 1 : -1));

    api.dashboard
      .getMetricData(buildingID)
      .then((res) => setFloor(res.sort((a, b) => (a.name > b.name ? 1 : -1))))
      .catch(console.log);

    api.floor.cpmGetDevData().then((res) => {
      if (res["NONGL_FIRE_FIGHTING_PUMP"]) {
        setFirePumpData(res["NONGL_FIRE_FIGHTING_PUMP"]);
      }
      if (res["NONGL_SS_DISEL_PUMP"]) {
        setDieselPumpData(res["NONGL_SS_DISEL_PUMP"]);
      }
    });
  }, []);

  // ── Fire Fighting Pump config ──────────────────────────────
  const firePumpAllowedParameters = {
    Fire_Pmp_Hydrent_Run_SS: <>Run Status</>,
    Fire_Pmp_Hydrent_Line_PressureA: (<>Hydrant Line<br />Pressure</>),
    Fire_Pmp_Hydrent_Trip_SS_Alarm: "Trip Status",
    Fire_Pmp_Jockey_Pump_01_Run_SS: <>Run Status</>,
    Fire_Pmp_Jockey_Pump_01_AM_SS: (<>Auto/Manual<br />Status</>),
    Fire_Pmp_Jockey_Pump_01_Trip_SS_Alarm: "Trip Status",
    Fire_Pmp_Jockey_Pump_02_Run_SS: <>Run Status</>,
    Fire_Pmp_Jockey_Pump_02_AM_SS: (<>Auto/Manual<br />Status</>),
    Fire_Pmp_Jockey_Pump_02_Trip_SS_Alarm: "Trip Status",
    Fire_Pmp_Sprinkler_Run_SS: <>Run Status</>,
    Fire_Pmp_Sprinkler_Line_PressureA: (<>Sprinkler Line<br />Pressure</>),
    Fire_Pmp_Sprinkler_Trip_SS_Alarm: "Trip Status",
  };

  const firePumpTypeMap = {
    Fire_Pmp_Hydrent_Run_SS: "Hydrant Pump",
    Fire_Pmp_Hydrent_Line_PressureA: "Hydrant Pump",
    Fire_Pmp_Hydrent_Trip_SS_Alarm: "Hydrant Pump",
    Fire_Pmp_Sprinkler_Run_SS: "Sprinkler Pump",
    Fire_Pmp_Sprinkler_Line_PressureA: "Sprinkler Pump",
    Fire_Pmp_Sprinkler_Trip_SS_Alarm: "Sprinkler Pump",
    Fire_Pmp_Jockey_Pump_01_Run_SS: "Jockey Pump 01",
    Fire_Pmp_Jockey_Pump_01_AM_SS: "Jockey Pump 01",
    Fire_Pmp_Jockey_Pump_01_Trip_SS_Alarm: "Jockey Pump 01",
    Fire_Pmp_Jockey_Pump_02_Run_SS: "Jockey Pump 02",
    Fire_Pmp_Jockey_Pump_02_AM_SS: "Jockey Pump 02",
    Fire_Pmp_Jockey_Pump_02_Trip_SS_Alarm: "Jockey Pump 02",
  };

  const getFirePumpTripColor = (attrKey, val) => {
    if (
      ["Fire_Pmp_Hydrent_Trip_SS_Alarm", "Fire_Pmp_Jockey_Pump_01_Trip_SS_Alarm",
        "Fire_Pmp_Jockey_Pump_02_Trip_SS_Alarm", "Fire_Pmp_Sprinkler_Trip_SS_Alarm"]
        .includes(attrKey)
    ) {
      return val === "1" || val === "active" || val === 1 ? "red" : "green";
    }
    return "#0123B4";
  };

  const formatFirePumpValue = (attrKey, val) => {
    if (val === null || val === undefined || val === "") return "-";
    const numVal = parseFloat(val);
    const isNumeric = !isNaN(numVal) && isFinite(numVal);
    switch (attrKey) {
      case "Fire_Pmp_Hydrent_Run_SS":
      case "Fire_Pmp_Jockey_Pump_01_Run_SS":
      case "Fire_Pmp_Jockey_Pump_02_Run_SS":
      case "Fire_Pmp_Sprinkler_Run_SS":
        return val === "active" || val === 1 || val === "1" ? "ON" : "OFF";
      case "Fire_Pmp_Jockey_Pump_01_AM_SS":
      case "Fire_Pmp_Jockey_Pump_02_AM_SS":
        return val === "active" || val === 1 || val === "1" ? "Auto" : "Manual";
      case "Fire_Pmp_Hydrent_Trip_SS_Alarm":
      case "Fire_Pmp_Jockey_Pump_01_Trip_SS_Alarm":
      case "Fire_Pmp_Jockey_Pump_02_Trip_SS_Alarm":
      case "Fire_Pmp_Sprinkler_Trip_SS_Alarm":
        return val === "active" || val === 1 || val === "1" ? "Trip" : "Normal";
      default:
        return isNumeric ? numVal.toFixed(2) : val;
    }
  };

  const renderPumpTypeCard = (groupName, attrs) => {
    if (!attrs || attrs.length === 0) return null;
    return (
      <Grid item xs={12} sm={6} key={groupName}>
        <Card className={classes.pumpTypeCard}>
          <div style={{
            fontWeight: "bold", fontSize: "2.2vh",
            marginBottom: "2vh", color: "black", textAlign: "left",
          }}>
            {groupName}
          </div>
          <Grid container spacing={1}>
            {attrs.map(([attrKey, attrValue]) => (
              <Grid item xs={12} sm={4} key={attrKey}>
                <Card className={classes.paper1}>
                  <div className={classes.cardHeading}>
                    {firePumpAllowedParameters[attrKey] || attrKey.replace(/_/g, " ")}
                  </div>
                  <div style={{
                    fontSize: "2.5vh",
                    color: getFirePumpTripColor(attrKey, attrValue.presentValue),
                    fontWeight: "bold", whiteSpace: "nowrap", marginBottom: "2vh",
                  }}>
                    {formatFirePumpValue(attrKey, attrValue.presentValue)}
                  </div>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Card>
      </Grid>
    );
  };

  // ── Diesel Pump config ─────────────────────────────────────
  const formatDieselValue = (val) => {
    if (val === null || val === undefined || val === "") return "-";
    let raw = typeof val === "object" ? val.presentValue : val;
    if (raw === "active" || raw === "1" || raw === 1) return "Auto";
    if (raw === "inactive" || raw === "0" || raw === 0) return "Manual";
    return raw;
  };

  // ── Floor filter ───────────────────────────────────────────
  const handleFloorChange = (name, id) => {
    setFId(id);
    setFdata(name);
  };

  const fireDevices = Object.entries(firePumpData).sort((a, b) =>
    a[1].name.localeCompare(b[1].name)
  );

  const dieselDevices = Object.entries(dieselPumpData).sort((a, b) =>
    a[1].name.localeCompare(b[1].name)
  );

  const parameterOrder = Object.keys(firePumpAllowedParameters);

  return (
    <div className={classes.root}>
      <Grid container spacing={2}>

        {/* Floor Dropdown */}
        <Grid item xs={12} style={{ marginLeft: "1vw" }}>
          <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
            <FormControl variant="filled" size="small"
              style={{ width: "max-content", minWidth: "100%", backgroundColor: "#eeeef5" }}>
              <Select
                labelId="floor-select" id="floor-select"
                className={classes.select} value={fdata}
                style={{ borderRadius: "0.8vw", height: "6vh", fontWeight: "bold" }}
                disableUnderline
              >
                <MenuItem value="all" onClick={() => handleFloorChange("all", "all")}>
                  All Floors
                </MenuItem>
                {floor.map((_item) => (
                  <MenuItem key={_item.name} value={_item.name}
                    onClick={() => handleFloorChange(_item.name, _item.id)}>
                    {_item.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>

        {/* ── Fire Fighting Pump Devices (with Diesel inside same card) ── */}
        {fireDevices
          .filter(([_, deviceInfo]) =>
            fid === "all" ? true : deviceInfo?.Equipment_Group === fid
          )
          .map(([deviceId, deviceInfo]) => {
            const filteredAttributes = deviceInfo?.Eqp_Attributes
              ? Object.entries(deviceInfo.Eqp_Attributes)
                .filter(([attrKey]) => Object.keys(firePumpAllowedParameters).includes(attrKey))
                .sort((a, b) => parameterOrder.indexOf(a[0]) - parameterOrder.indexOf(b[0]))
              : [];

            const groupedAttributes = {};
            filteredAttributes.forEach(([attrKey, attrValue]) => {
              const groupName = firePumpTypeMap[attrKey] || "Other";
              if (!groupedAttributes[groupName]) groupedAttributes[groupName] = [];
              groupedAttributes[groupName].push([attrKey, attrValue]);
            });

            return (
              <Grid item xs={12} key={deviceId}>
                <Card className={classes.paper} style={{ height: "auto", minHeight: "50vh", padding: "2vh" }}>
                  <Grid container spacing={2}>

                    {/* ── Fire Pump Header ── */}
                    <Grid item xs={12}>
                      <div style={{
                        color: "black", fontWeight: "bold",
                        fontSize: "2.8vh", textAlign: "left", marginBottom: "2vh",
                      }}>
                        {deviceInfo.name}
                      </div>
                    </Grid>

                    {/* ── Fire Pump Content ── */}
                    <Grid item xs={12}>
                      <Grid container spacing={2}>
                        {/* Fire Pump Image */}
                        <Grid item xs={12} sm={3} md={2}>
                          <div style={{
                            display: "flex", justifyContent: "center",
                            alignItems: "center", height: "100%", minHeight: "40vh",
                          }}>
                            <img src={firefightingpump} alt="Fire Fighting Pump"
                              style={{ width: "100%", maxWidth: "150px", height: "auto", objectFit: "contain" }} />
                          </div>
                        </Grid>

                        {/* Fire Pump Type Cards */}
                        <Grid item xs={12} sm={9} md={10}>
                          <Grid container spacing={2}>
                            {renderPumpTypeCard("Hydrant Pump", groupedAttributes["Hydrant Pump"])}
                            {renderPumpTypeCard("Sprinkler Pump", groupedAttributes["Sprinkler Pump"])}
                            {renderPumpTypeCard("Jockey Pump 01", groupedAttributes["Jockey Pump 01"])}
                            {renderPumpTypeCard("Jockey Pump 02", groupedAttributes["Jockey Pump 02"])}
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>

                    {/* ── Diesel Pump Section inside same card ── */}
                    {dieselDevices
                      .filter(([_, dInfo]) =>
                        fid === "all" ? true : dInfo?.Equipment_Group === fid
                      )
                      .map(([dieselId, dieselInfo]) => {
                        const attrs = dieselInfo?.Eqp_Attributes || {};
                        let raw = attrs.DISEL_Am_SS;
                        if (raw && typeof raw === "object") raw = raw.presentValue;

                        return (
                          <React.Fragment key={dieselId}>
                            {/* Divider */}
                            <Grid item xs={12}>
                              <div style={{ borderTop: "1px solid #e0e0e0", margin: "1vh 0" }} />
                            </Grid>

                            {/* Diesel Header */}
                            <Grid item xs={12}>
                              <div style={{
                                color: "black", fontWeight: "bold",
                                fontSize: "2.8vh", textAlign: "left", marginBottom: "2vh",
                              }}>
                                {dieselInfo.name}
                              </div>
                            </Grid>

                            {/* Diesel Content */}
                            <Grid item xs={12}>
                              <Grid container spacing={2}>
                                {/* Diesel Image */}
                                <Grid item xs={12} sm={3} md={2}>
                                  <div style={{
                                    display: "flex", justifyContent: "center",
                                    alignItems: "center", height: "100%", minHeight: "15vh",
                                  }}>
                                    <img src={dieselPumpImg} alt="Diesel Pump"
                                      style={{ width: "100%", maxWidth: "150px", height: "auto", objectFit: "contain" }} />
                                  </div>
                                </Grid>

                                {/* Diesel Status Card */}
                                <Grid item xs={12} sm={9} md={10}>
                                  <Grid container spacing={2}>
                                    <Grid item xs={12} sm={6}>
                                      <Card className={classes.pumpTypeCard}>
                                        <div style={{
                                          fontWeight: "bold", fontSize: "2.2vh",
                                          marginBottom: "2vh", color: "black", textAlign: "left",
                                        }}>
                                          Diesel Pump
                                        </div>
                                        <Grid container spacing={1}>
                                          <Grid item xs={12} sm={4}>
                                            <Card className={classes.paper1}>
                                              <div className={classes.cardHeading}>
                                                Auto/Manual Status
                                              </div>
                                              <div style={{
                                                fontSize: "2.5vh", color: "#0123B4",
                                                fontWeight: "bold", whiteSpace: "nowrap", marginBottom: "2vh",
                                              }}>
                                                {formatDieselValue(raw)}
                                              </div>
                                            </Card>
                                          </Grid>
                                        </Grid>
                                      </Card>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </Grid>
                            </Grid>
                          </React.Fragment>
                        );
                      })}

                  </Grid>
                </Card>
              </Grid>
            );
          })}

      </Grid>
    </div>
  );
}